import Button from "@/components/button/Button"
import { useGlobalContext } from "@/components/context/GlobalContext"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useResendEmailConfirmationOnLoginMutation } from "@/graphql"
import { Col, message, Row } from "antd"
import { FC } from "react"
import { useParams } from "react-router-dom"
import "./ExpiredConfirmationLink.less"

const { Title, Paragraph } = WebsiteTypography

const ExpiredConfirmationLink: FC = () => {
  const { loginEmail } = useGlobalContext()
  const { setModalDarkTypes } = useModalDarkContext()
  const { org } = useParams()
  const [resendEmailConfirmation, { loading: emailResending }] = useResendEmailConfirmationOnLoginMutation()

  const getReadableError = (rawMessage: string) => {
    const cleanMessage = rawMessage.replace(/^graphql error:\s*/i, "").trim()
    const lowerMessage = cleanMessage.toLowerCase()

    if (lowerMessage.includes("already confirmed")) {
      return "Your email is already confirmed. Please sign in."
    }

    if (
      lowerMessage.includes("mailgun") ||
      lowerMessage.includes("mimecast") ||
      lowerMessage.includes("delivery") ||
      lowerMessage.includes("could not deliver")
    ) {
      return "We could not deliver the confirmation email to this mailbox. Please check spam/junk. If your company uses Mimecast or another email security gateway, ask IT to allow our emails and try again."
    }

    return cleanMessage || "Could not resend confirmation email right now. Please try again shortly."
  }

  const handleResendEmail = async () => {
    loginEmail &&
      org &&
      (await resendEmailConfirmation({
        variables: {
          input: { orgSlug: org, userEmail: loginEmail },
        },
        onCompleted: () => {
          // BlackNotification("Email Confirmation Resent Successfully")
          setModalDarkTypes("email-sending-confirmation")
        },
        onError: e => {
          message.error(getReadableError(e.message))
        },
      }))
  }

  return (
    <Row justify={"center"} className={"email-not-confirmed-wrapper"} style={{ paddingTop: 24, paddingBottom: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Title level={3} centered className={"section-title"} style={{ paddingBottom: 24 }}>
          <span className={"w300"}>{"Your Email Confirmation Link "}</span>
          <span className={"bold"}>{"Expired"}</span>
        </Title>

        <Row justify={"center"}>
          <div className={"hex-wrapper"}>
            <SvgIcon type={"envelope-with-lock"} />
          </div>
        </Row>

        <Row justify={"center"}>
          <Col span={18}>
            <Paragraph
              centered
              size={"md"}
              style={{ paddingTop: 24, paddingBottom: 24 }}
              color={"website-secondary"}
              weight={"w300"}
            >
              {"Your confirmation link has expired, or your email address has already been confirmed."}
            </Paragraph>
          </Col>
        </Row>
      </Col>

      <Row justify={"center"} className={"divider-with-hex"} style={{ margin: "0 0 24px 0" }}>
        <div className={"hex-small"} />
      </Row>

      <Row justify={"center"}>
        <Paragraph weight={"w300"} size={"md"} color={"website-secondary"} centered>
          {
            'If you are unable to log in and still see the "Email Not Confirmed" message, please request a new confirmation link by clicking the button below.'
          }
        </Paragraph>
      </Row>

      <Col span={24} style={{ paddingTop: 32 }}>
        <Row justify={"center"}>
          <Button
            btnType={"primary"}
            text={"Re-send Confirmation Email"}
            onClick={handleResendEmail}
            loading={emailResending}
          />
        </Row>
      </Col>
    </Row>
  )
}

export default ExpiredConfirmationLink
